<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import * as authStore from "@/services/authService";

const router = useRouter();
const fadeOut = ref(false);

onMounted(() => {
  setTimeout(async () => {
    await authStore.logout();
    fadeOut.value = true;
    setTimeout(() => {
      router.push("/login");
    }, 800); // Pequeña espera para la animación
  }, 2000);
});
</script>

<template>
  <div
      class="fixed inset-0 flex flex-col justify-center items-center bg-gray-100 dark:bg-gray-900 transition-opacity duration-700"
      :class="{ 'opacity-0': fadeOut }"
  >
    <!-- Spinner con animación -->
    <div class="w-16 h-16 border-4 border-red-500 border-t-transparent rounded-full animate-spin"></div>

    <!-- Texto animado -->
    <h1 class="mt-4 text-xl font-semibold text-gray-700 dark:text-gray-300 animate-pulse">
      Logging out...
    </h1>

    <!-- Desvanecimiento sutil -->
  </div>
</template>

<style scoped>
/* Animación para desvanecer */
.opacity-0 {
  opacity: 0;
}
</style>
